<script setup lang="ts">
const { t, tm, rt } = useI18n()

type Step = { n: string; title: string; text: string }
const resolve = (key: string): Step[] =>
  (tm(key) as any[]).map((s) => ({ n: rt(s.n), title: rt(s.title), text: rt(s.text) }))

const courierSteps  = computed(() => resolve('how.courier'))
const customerSteps = computed(() => resolve('how.customer'))
</script>

<template>
  <section id="how" class="rod-section relative">
    <div class="rod-container">
      <div class="grid lg:grid-cols-2 gap-12 lg:gap-16">
        <!-- COURIER column — cyan, matching the mobile app's primary brand -->
        <div data-reveal>
          <div class="rod-eyebrow mb-5"
               style="background: rgba(20,197,219,0.10); border-color: rgba(20,197,219,0.30); color: var(--color-cyan-300);">
            🛫 {{ t('how.eyebrow') }}
          </div>
          <h2 class="rod-h2 mb-10">
            <span v-html="t('how.titleA')" />
          </h2>

          <div class="relative">
            <!-- vertical line -->
            <div class="absolute left-6 top-2 bottom-2 w-px"
                 style="background: linear-gradient(to bottom, rgba(20,197,219,0.55), rgba(20,197,219,0));"></div>

            <div class="flex flex-col gap-8">
              <div v-for="step in courierSteps" :key="step.n" class="flex gap-5 items-start">
                <div class="relative flex-shrink-0 w-12 h-12 rounded-full grid place-items-center font-display font-bold text-base z-10"
                     style="background: linear-gradient(135deg, #22D3EE 0%, #14C5DB 60%, #0EA5C0 100%);
                            color: #052B33;
                            box-shadow: 0 8px 24px -6px rgba(20,197,219,0.45);">
                  {{ step.n }}
                </div>
                <div>
                  <h3 class="rod-h3 mb-2">{{ step.title }}</h3>
                  <p class="text-[var(--color-text-muted)] leading-relaxed">{{ step.text }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- CUSTOMER column — gold, matching the duty-free / retail warmth -->
        <div data-reveal>
          <div class="rod-eyebrow mb-5">📦 {{ t('how.eyebrow') }}</div>
          <h2 class="rod-h2 mb-10">
            <span v-html="t('how.titleB')" />
          </h2>

          <div class="relative">
            <div class="absolute left-6 top-2 bottom-2 w-px bg-gradient-to-b from-amber-400/55 to-amber-400/0"></div>

            <div class="flex flex-col gap-8">
              <div v-for="step in customerSteps" :key="step.n" class="flex gap-5 items-start">
                <div class="relative flex-shrink-0 w-12 h-12 rounded-full bg-gradient-to-br from-amber-300 via-amber-400 to-orange-500 grid place-items-center text-[#0A0A0F] font-display font-bold text-base z-10 shadow-lg shadow-amber-500/30">
                  {{ step.n }}
                </div>
                <div>
                  <h3 class="rod-h3 mb-2">{{ step.title }}</h3>
                  <p class="text-[var(--color-text-muted)] leading-relaxed">{{ step.text }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
